import { DownOutlined } from "@ant-design/icons";
import { Form, Tree } from "antd";
import React, { useEffect, useState } from "react";
import { get_rutas } from "../../../../actions/usuario";

const fn_LoadChildren = ({ allRutas = [], patternId }) => {
  let opts = [];
  const childrens = allRutas?.filter((x) => x.rutapadre === patternId);
  childrens.forEach((row) => {
    let objRuta = {
      title: row?.nombre,
      key: row?.id,
      isLeaf: row?.eslink,
      data: row,
    };
    const childs = allRutas?.filter((x) => x.rutapadre === row?.id);
    if (childs.length > 0) {
      let objRutaChild = fn_LoadChildren({ allRutas, patternId: row?.id });
      objRuta = { ...objRuta, children: objRutaChild };
    }
    opts = [...opts, objRuta];
  });
  return opts;
};
const getAllKeys = (data) => {
  return (
    data?.flatMap((record) => [
      record.key,
      ...(record.children ? getAllKeys(record.children) : []),
    ]) || []
  );
};
export const AccesoPerfilTree = ({ keysChecked, onCheck }) => {
  const form = Form.useFormInstance();
  const accesosgrupo = Form.useWatch("accesosgrupo", form);
  const [data, setData] = useState([]);
  const [keysExpanded, setKeysExpanded] = useState([]);
  useEffect(() => {
    const OnLoad = async () => {
      const data = await get_rutas();
      const datos = fn_LoadChildren({ allRutas: data, patternId: null });
      const allKeys = getAllKeys(datos);
      setData(datos);
      setKeysExpanded(allKeys);
    };
    OnLoad();
    return () => {
      setData([]);
    };
  }, []);

  useEffect(() => {
    const keysInitialChecked = accesosgrupo?.map((row) => row?.ruta);
    onCheck(keysInitialChecked);
    return () => {
      onCheck([]);
    };
  }, [accesosgrupo]);

  const onExpand = (keys, info) => {
    setKeysExpanded(keys);
  };
  return (
    <Tree.DirectoryTree
      checkable
      showLine
      treeData={data}
      switcherIcon={<DownOutlined />}
      expandedKeys={keysExpanded}
      checkedKeys={keysChecked}
      onExpand={onExpand}
      onCheck={onCheck}
    />
  );
};
